<template>
  <v-container fluid class="ma-0 pa-2">
    <v-app-bar app class="primary">
      <v-icon color="white" large>library_books</v-icon>
      <v-toolbar-title class="white--text pl-2"
        >Saved Study Datasets
        <div class="subtitle-1">Select/View/Analyze Dataset</div>
      </v-toolbar-title>
    </v-app-bar>

    <!-- the user's own study datasets -->
    <v-container fluid fill-width class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-sheet color="white" class="scroll rounded-lg shadow mt-2">
            <v-container fluid fill-width class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-card color="#eeeeee" class="pt-1">
                    <v-card-title class="primary--text pl-3 py-2"
                      >My Saved Study Datasets
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <loading-spinner
              v-if="isLoading"
              medium
              class="pb-5"
            ></loading-spinner>

            <collection-table
              v-else
              class="pb-1"
              :collections="userCollections"
              :show-data-export="allowDataExport"
              :show-share-option="true"
              :show-data-copy="allowDataCopy"
              :show-group="true"
              :dense="true"
              @collectionShared="collectionShared"
              @collectionCopied="collectionCopied"
            ></collection-table>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <!-- other study datasets that the user can view -->
    <v-container
      v-if="sharedCollections.length > 0"
      fluid
      fill-width
      class="pa-0 ma-0"
    >
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-sheet color="white" class="scroll rounded-lg shadow mt-2">
            <v-container fluid fill-width class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-card color="#eeeeee" class="pt-1">
                    <v-card-title class="primary--text pl-3 py-2"
                      >Study Datasets Shared With Me
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <loading-spinner
              v-if="isLoading"
              medium
              class="pb-5"
            ></loading-spinner>

            <collection-table
              v-else
              class="pb-1"
              :collections="sharedCollections"
              :show-data-export="allowDataExport"
              :show-data-copy="allowDataCopy"
              :show-owner="true"
              :show-group="true"
              :dense="true"
              @collectionCopied="collectionCopied"
            ></collection-table>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import CollectionTable from '@/components/DatasetManager/CollectionTable.vue';
import { mapState, mapActions } from 'vuex';
import { state, actions } from '@/store/modules/datasetManager/types';

export default {
  components: {
    CollectionTable,
  },
  data() {
    return {
      allowDataExport: false,
      allowDataCopy: false,
      userCollections: [],
      sharedCollections: [],
    };
  },
  computed: {
    ...mapState('datasetManager', {
      isLoading: state.IS_LOADING,
      collections: state.COLLECTIONS,
    }),
  },
  watch: {
    collections(cs) {
      let user = [];
      let shared = [];
      cs.forEach(c => {
        c.is_longitudinal =
          c.studies.length > 0 && c.studies[0].study.longitudinal;
        if (c.is_deletable) {
          // currently a proxy for ownership
          user.push(c);
        } else {
          shared.push(c);
        }
      });
      this.userCollections = user;
      this.sharedCollections = shared;
    },
  },
  async created() {
    axios.get('/api/user_groups').then(({ data }) => {
      if ('groups' in data) {
        let groups = data.groups;
        let dataExporter = false;
        let dataCopier = false;
        groups.forEach(g => {
          if (g.name == 'Data Exporters') dataExporter = true;
          if (g.name == 'Data Copiers') dataCopier = true;
        });
        this.allowDataExport = dataExporter;
        this.allowDataCopy = dataCopier;
      }
    });
  },
  mounted() {
    if (!this.isLoading) {
      this.fetchDatasets();
    }
  },
  methods: {
    ...mapActions('datasetManager', {
      fetchDatasets: actions.FETCH_COLLECTIONS,
      deleteCollection: actions.DELETE_COLLECTION,
    }),
    collectionShared(_c) {
      if (!this.isLoading) {
        this.fetchDatasets();
      }
    },
    collectionCopied(_c) {
      if (!this.isLoading) {
        this.fetchDatasets();
      }
    },
  },
};
</script>

<style scoped></style>
